// This file is automatically generated. Do not edit manually.

import { ChartGroupBoxPlotSource } from "src/api/generated/spc/controlChart/analysis/chartGroupBoxPlotSource";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ChartGroupBoxPlotApi {
	export async function getChartGroupBoxPlot(args: {
		chartGroupId: number;
		recordCount: number;
	}): Promise<ChartGroupBoxPlotSource> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/chartGroupBoxPlot/getChartGroupBoxPlot",
			method: "POST",
			data: {
				chartGroupId: args.chartGroupId,
				recordCount: args.recordCount,
			},
		});
		return response as ChartGroupBoxPlotSource;
	}
}
